import Alarms from "assets/SvgIcon/Chart/Alarms";
import EditTags from "assets/SvgIcon/Chart/EditTags";
import MultiPlot from "assets/SvgIcon/Chart/MultiPlot";
import MultiYPlot from "assets/SvgIcon/Chart/MultiYPlot";
import NormalizedSeries from "assets/SvgIcon/Chart/NormalizedSeries";
import SinglePlot from "assets/SvgIcon/Chart/SinglePlot";

const CHART_HEADER_BUTTONS = {
  SINGLE_PLOT: SinglePlot,
  MULTI_Y_PLOT: MultiYPlot,
  MULTI_PLOT: MultiPlot,
  EDIT_ALARMS: Alarms,
  EDIT_TAGS: EditTags,
  EDIT_NORMALIZE_FILTERS: NormalizedSeries
};

export default CHART_HEADER_BUTTONS;
